
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbDatepicker, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerConfig, NgbCalendar, NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { BookingService } from '../../../../core/services/booking.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
declare let gtag: (property: string, value: any, configs: any) => {};
@Component({
  selector: 'app-datetime-change-booking',
  templateUrl: './datetime-change-booking.component.html',
  styleUrls: ['./datetime-change-booking.component.scss']
})
export class DatetimeChangeBookingComponent implements OnInit {
  infoWindowOpened = null;
  previousInfoWindow = null;
  model: NgbDateStruct;
  @ViewChild('dp') datepicker: NgbDatepicker;
  public data: any = [];
  public date: string;
  public myMoment: string;
  public markDisabled;
  public btnDatetime = 1;
  // public data_plants:any = [];
  public dataPlants: any = [];
  public arrows: any;
  public dateSelected: string;

  /* Ngb-datepicker properties */
  outsideDays;
  minimumDate;
  maximumDate;
  disabledDays;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private bookingService: BookingService,
    private route: Router,
    private ngxLoader: NgxUiLoaderService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.setCalendarConfig();
    this.bookingService.getDataChangeBooking().subscribe((response) => {
      this.dateSelected = response.date;
      this.takeDays();
      if (this.dateSelected === undefined) {
        this.route.navigateByUrl('/');
      }
    });
  }

  /* This sets the initial calendar configuration > No sundays and min/max date range */
  public setCalendarConfig() {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    this.minimumDate = { year, month, day }; // Minimum available date
    this.maximumDate = { year: (year + 1), month: 12, day: 31 }; // Maximum available date
    this.outsideDays = 'hidden';

    // sundays are disabled
    this.disabledDays = (date: NgbDate) => {
      const d = new Date(date.year, date.month - 1, date.day);
      return d.getDay() === 0;
    };
  }

  selectDatetime() {
    if (this.model !== undefined) {
      this.ngxLoader.start();
      const date = (this.model.year + '-' + this.model.month + '-' + this.model.day);
      this.myMoment = moment(date).format('YYYY-MM-DD');
      gtag('event', 'Reagenda3', {'event_category': 'Reagenda3', 'event_label': 'Reagenda3', 'value': 'Reagenda3'});
      this.bookingService.getBookingAvailability(this.myMoment).subscribe(
        response => {
          this.ngxLoader.stop();
          if (response.status === true) {
            this.bookingService.setAvailability(response.message);
            this.route.navigateByUrl('/booking/select-datetime');
          }
        }
      );
    }
  }

  onDateSelect(event) {
    this.btnDatetime = 0;
  }

  takeDays(includeNextMonth = false) {
    const date = moment(this.dateSelected, 'YYYY-MM-DD').format();
    const now = new Date(date);
    this.model = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
    if(includeNextMonth)
      this.datepicker.navigateTo(this.model);
  }
  getCalendarAvailability(event, includeNextMonth = false){
    const month = event.month;
    const year =  event.year;
    const lastDateInMonth = new Date(year, month, 0);
    const systemDate = new Date();
    this.bookingService.getCalendarAvailability(month, year).subscribe((response) =>{
      if(response.message && response.status){
        this.disabledDays = (date: NgbDate) => {
          const d = new Date(date.year, date.month - 1, date.day);
          return !(response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== null  && response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== undefined); 
        };
        if(response.message.length > 0){
          this.takeDays(includeNextMonth);
        }
        else{
          if (lastDateInMonth.getDate() == systemDate.getDate() && !includeNextMonth) {
            includeNextMonth = true;
            event.month += 1;
            if (event.month > 12) {
              event.month = 1;
              event.year += 1;
            }
            return this.getCalendarAvailability(event, includeNextMonth);
          }
          else this.toastr.error("Agenda No disponible");
        }
      }
      this.ngxLoader.stop();
    });
  }
  public getAvailabilityinNextMonth(month, year){
    var init_date = `${month}-01-${year}`;
    var end_date = `${month}-31-${year}`;
    var daysInMonth = new Date(year, month, 0).getDate();
    this.bookingService.getAvailabilityByPlantAndMonth(init_date, end_date).subscribe((response) =>{
      if(response.message && response.status){
        this.maximumDate = { year: year, month: month, day: daysInMonth };
      }
    });
  }
  pickUpDate(event) {
    this.ngxLoader.start();
    var month = event.month + 1;
    var year = event.year;
    if(month > 12){
      month = 1;
      year += 1; 
    }
    this.getAvailabilityinNextMonth(month, year);
    this.getCalendarAvailability(event);
  }

  /* Disable days based on the ms mandatory returned days */
  public isDisabled(availableDays, year, month) {
    const daysOfMonth = new Date(year, month, 0).getDate(); // This returns the total days of the month (number)
    const disabledDates: NgbDateStruct[] = [];
    /* This finds and push to the disabled days all sundays */
    for (let i = 0; daysOfMonth >= i; i++) {
      const date = new Date(year, month - 1, i);
      if (date.getDay() === 0) {
        disabledDates.push({ year, month, day: date.getDate() });
      }
    }
    /* This looks for all holydays that comes in the not-worked-days service */
    availableDays.message.days.forEach(element => {
      disabledDates.push({ year, month, day: element.day });
    });
    /* Then the disabled days are set */
    this.disabledDays = (dateStruct: NgbDateStruct) => {
      return disabledDates.find(date => new NgbDate(date.year, date.month, date.day).equals(dateStruct));
    };
  }

  /* Modal */
  openModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
  }
}
